import { useTranslation } from 'react-i18next';
import type { ProcessRunStatus } from '@econtractor/types';

interface ProcessStatusBadgeProps {
    status: ProcessRunStatus;
}

const statusClass: Record<ProcessRunStatus, string> = {
    draft: 'bg-light-secondary text-secondary',
    active: 'bg-light-primary',
    done: 'bg-light-success text-success',
};

const ProcessStatusBadge = ({ status }: ProcessStatusBadgeProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <span className={`badge ${statusClass[status] || statusClass.draft} fs-12`}>
            {t(`processRuns.status.${status}`)}
        </span>
    );
};

export default ProcessStatusBadge;
